import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover esta locação para o carro com a placa <b>${this.currentEntity.car.plate}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/rent-parking/resources/computed.js